import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
   
   @Pipe({
     name: 'tovpilDate'
   })
   export class TovpilDatePipe extends 
        DatePipe implements PipeTransform {

        constructor(@Inject(LOCALE_ID) locale: string) {
            super(locale);
        }

     transform(value: any, format?: string, timezone?: string, locale?: string): any {
        let year = value.slice(0,4);
        let month = value.slice(4, 6) - 1;
        let day = value.slice(6, 8);
        let date = new Date(year, month, day);
        return super.transform(date, format, timezone, locale);
     }
   }